import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ProducciNMusicalIntegral from "./sections/ProducciNMusicalIntegral";
import SolucionesParaEmpresas from "./sections/SolucionesParaEmpresas";
import Nonreligiousmusicservices from "./sections/Nonreligiousmusicservices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ProducciNMusicalIntegral />
      <Nonreligiousmusicservices />
      <SolucionesParaEmpresas />
      <Footer />
    </div>;
}